module.exports = __webpack_public_path__ + "img/coming-soon-light.396b9f03.svg";